import type { enReports } from "./en.reports";

/** Russian for the report engine (see `en.reports.ts`). Words from the boards Report…PeriodPicker. */
export const ruReports: Record<keyof typeof enReports, string> = {
  "period.cmp.custom": "свой период",
  "period.from": "С",
  "period.to": "По",
  "period.cmpFrom": "Сравнить с",
  "period.cmpTo": "по",
  "period.legend.period": "период",
  "period.legend.compare": "сравнение",
  "period.todaySuffix": "сегодня",
  "period.note": "день по {tz} · меняется в Настройках",
  "rep.title": "Отчёт",
  "rep.views": "Отчёты",
  "rep.view.ads": "По объявлениям",
  "rep.view.time": "По гео и часам",
  "rep.view.landers": "Ленды",
  "rep.view.offers": "Офферы по партнёркам",
  "rep.views.more": "Ещё {n}",
  "rep.views.moreAria": "Ещё отчётов: {n}",
  "rep.views.chip": "Отчёт «{name}»",
  "rep.views.chipShared": "Отчёт «{name}», виден всем",
  "rep.views.delete": "Удалить отчёт «{name}»",
  "rep.views.createAria": "Сохранить текущий отчёт как вид",
  "rep.views.deleted": "Отчёт «{name}» удалён",
  "rep.views.save": "Сохранить вид",
  "rep.views.all": "Все отчёты",
  "rep.views.find": "Найти отчёт",
  "rep.views.builtin": "Встроенные",
  "rep.views.saved": "Сохранённые",
  "rep.views.workspace": "Пространство",
  "rep.views.unknownAuthor": "кто-то",
  "rep.views.mine": "мой",
  "rep.views.copyLink": "Скопировать ссылку на «{name}»",
  "rep.views.actions": "Действия с «{name}»",
  "rep.save": "Сохранить",
  "rep.saved": "Отчёт «{name}» сохранён",
  "rep.saveFailed": "Не удалось сохранить",
  "rep.link": "Ссылка",
  "rep.linkCopied": "Ссылка на отчёт скопирована",
  "rep.csvEmpty": "В отчёте нет строк",
  "rep.cancel": "Отмена",
  "rep.close": "Закрыть",
  "rep.loading": "Считаем…",
  "rep.nothingFound": "Ничего не нашлось",
  "rep.naming": "Загружаем название…",
  "rep.fold.chosen": "{chosen} из {total}",
  "rep.fold.collapse": "{name} — свернуть",
  "rep.fold.expand": "{name} — развернуть",
  "rep.error": "Не удалось построить отчёт",
  "rep.grouping": "Группировка",
  "rep.level.add": "+ уровень",
  "rep.level.search": "Найти измерение или sub-метку",
  "rep.level.keys": "↑↓ выбрать · ↵ добавить уровень",
  "rep.level.order": "Порядок уровней — перетащите:",
  "rep.level.n": "уровень {n}",
  "rep.level.count": "{n} из {max}",
  "rep.level.remove": "Убрать уровень «{name}»",
  "rep.level.move": "Переместить «{name}» — перетащите или Alt+←/→",
  "rep.group.source": "Источник",
  "rep.group.path": "Кампания",
  "rep.group.campaign": "Кампания",
  "rep.group.ad": "Объявление",
  "rep.group.funnel": "Воронка",
  "rep.group.labels": "Метки",
  "rep.group.geo": "Гео",
  "rep.group.device": "Устройство",
  "rep.group.network": "Сеть",
  "rep.group.time": "Время",
  "rep.group.conversion": "Конверсия",
  "rep.group.quality": "Качество",
  "rep.basis": "Конверсии по",
  "rep.basis.lead": "дате лида",
  "rep.basis.conv": "дате конверсии",
  "rep.basis.click": "дате клика",
  "rep.compare": "Сравнить",
  "rep.compare.short": "Сравнить",
  "rep.compare.against": "против",
  "rep.compare.prev": "прошлый период",
  "rep.compare.year": "год назад",
  "rep.compare.view": "Как показать сравнение",
  "rep.compare.side": "Рядом",
  "rep.compare.delta": "Только Δ",
  "rep.compare.sortedBy": "сортировка по «{metric}»",
  "rep.compare.live": "{day} ещё идёт",
  "rep.was": "было {value}",
  "rep.prevValue": "было {value}",
  "rep.filters": "Фильтры",
  "rep.filters.reset": "Сбросить все",
  "rep.pinned": "закреплено",
  "rep.pinned.hint": "Отчёт открыт отсюда — этот фильтр не снимается",
  "rep.filter": "Фильтр",
  "rep.filter.dims": "Измерения",
  "rep.filter.metrics": "Метрики",
  "rep.filter.byMetric": "Условие по метрике",
  "rep.filter.metric": "Метрика",
  "rep.filter.op": "Условие",
  "rep.filter.value": "Значение",
  "rep.filter.removeCondition": "Убрать условие",
  "rep.filter.addCondition": "условие",
  "rep.filter.where": "Условия по метрикам проверяются на уровне строки отчёта, по измерениям — до группировки.",
  "rep.filter.in": "входит в",
  "rep.filter.notInLong": "не входит",
  "rep.filter.notIn": "не",
  "rep.filter.contains": "содержит",
  "rep.filter.notContains": "не содержит",
  "rep.filter.find": "Найти: {what}",
  "rep.filter.valuesNote": "Число справа — клики за период. Выбрано {n}.",
  "rep.filter.found": "Найдено {what}",
  "rep.filter.reset": "Сбросить",
  "rep.filter.apply": "Применить",
  "rep.band.traffic": "Трафик",
  "rep.band.conversions": "Конверсии",
  "rep.band.money": "Деньги",
  "rep.band.custom": "Свои",
  "rep.band.collapse": "свернуть",
  "rep.band.expand": "развернуть",
  "rep.band.running": "идёт",
  "rep.band.series": "Что по дням",
  "rep.band.roi": "ROI",
  "rep.band.vsPrev": "к прошлым {n}",
  "rep.band.this": "этот период",
  "rep.band.prev": "прошлые {n} дн.",
  "rep.series.profit": "Профит по дням",
  "rep.series.leads": "Лиды по дням",
  "rep.series.cr": "CR по дням",
  "rep.series.clicks": "Клики по дням",
  "rep.series.short.profit": "Профит",
  "rep.series.short.leads": "Лиды",
  "rep.series.short.cr": "CR",
  "rep.series.short.clicks": "Клики",
  "rep.col.payout": "Выплата",
  "rep.col.roi": "ROI",
  "rep.col.landerCr": "CR после ленда",
  "rep.col.landerEpc": "Доход на визит ленда",
  "rep.total": "Итого, {what}",
  "rep.total.short": "Итого",
  "rep.total.csv": "Итого",
  "rep.columns": "Колонки: {set}",
  "rep.columns.title": "Колонки",
  "rep.columns.description": "Какие числа показывает отчёт",
  "rep.columns.sets": "Набор",
  "rep.columns.save": "Сохранить как набор",
  "rep.columns.reset": "Сбросить",
  "rep.columns.empty": "Нечего выбрать",
  "rep.columns.caption": "Набор:",
  "rep.columns.search": "Найти метрику",
  "rep.columns.clearSearch": "Очистить поиск",
  "rep.columns.noMatches": "Нет метрики «{query}»",
  "rep.columns.count": "{shown} из {total}",
  "rep.set.money": "Деньги",
  "rep.set.funnel": "Воронка",
  "rep.set.quality": "Качество трафика",
  "rep.set.compare": "Сравнение",
  "rep.set.own": "свои",
  "rep.set.mine": "Мои колонки",
  "rep.set.mineChip": "Мои",
  "rep.band.goals": "Цели",
  "rep.set.saved": "Набор «{name}» сохранён",
  "rep.formula.add": "Своя формула",
  "rep.formula.title": "Своя метрика",
  "rep.formula.editTitle": "Изменить метрику",
  "rep.formula.body": "Появится в колонках всех отчётов и списка кампаний этого пространства.",
  "rep.formula.name": "Название",
  "rep.formula.namePlaceholder": "Например: Профит на лид",
  "rep.formula.formula": "Формула",
  "rep.formula.placeholder": "Наберите метрику или нажмите её ниже",
  "rep.formula.palette": "Вставить в формулу",
  "rep.formula.unit": "Формат",
  "rep.formula.unit.number": "Число",
  "rep.formula.unit.money": "Деньги",
  "rep.formula.decimals": "Знаков после запятой",
  "rep.formula.better": "Лучше, когда",
  "rep.formula.better.higher": "больше",
  "rep.formula.better.lower": "меньше",
  "rep.formula.check": "Проверка на текущем отчёте",
  "rep.formula.checkOver": "итого · {text}",
  "rep.formula.zero": "Деление на ноль показывается как «—».",
  "rep.formula.create": "Добавить метрику",
  "rep.formula.save": "Сохранить",
  "rep.formula.delete": "Удалить",
  "rep.formula.created": "Метрика «{name}» добавлена",
  "rep.formula.updated": "Метрика «{name}» сохранена",
  "rep.formula.deleted": "Метрика «{name}» удалена",
  "rep.formula.error.empty": "Формула пуста",
  "rep.formula.error.unbalanced": "Скобки не сходятся",
  "rep.formula.error.incomplete": "Формула не закончена",
  "rep.formula.error.unknown-metric": "В формуле метрика, которой больше нет",
  "rep.save.title": "Сохранить отчёт",
  "rep.save.body": "Отчёт появится рядом с «По объявлениям» и откроется по ссылке.",
  "rep.save.name": "Название",
  "rep.save.placeholder": "Например: Нутра RO · по объявлениям",
  "rep.save.what": "Что сохраняется",
  "rep.save.columns": "Колонки",
  "rep.save.columns.set": "набор «{set}», {n} колонок",
  "rep.save.columns.own": "свои, {n} колонок",
  "rep.save.noFilters": "без фильтров",
  "rep.save.comparePrev": "сравнение с прошлым периодом",
  "rep.save.compareYear": "сравнение с прошлым годом",
  "rep.save.keepPeriod": "Запомнить период {period}",
  "rep.save.keepPeriod.else": "иначе — период из топбара",
  "rep.save.shared": "Видно всем в пространстве {workspace}",
  "rep.save.shared.hint": "Другие смогут открыть и скопировать, менять — только вы",
  "rep.save.nameTaken": "Имя занято? Добавим «(2)»",
  "rep.save.submit": "Сохранить",
  "rep.empty.filtered": "По этим фильтрам строк нет",
  "rep.empty.filtered.one": "За {period} нет строк, где {where}. Уберите это условие или расширьте период.",
  "rep.empty.filtered.many": "За {period} нет строк, где {where}. Уберите «{last}» или расширьте период.",
  "rep.empty.and": "и",
  "rep.empty.period": "За период строк нет",
  "rep.empty.period.body": "За {period} кликов и конверсий нет. Пусто ≠ сломано: строка здоровья внизу показывает, что клики и постбеки приходят.",
  "rep.empty.30d": "30 дней",
  "rep.empty.reset": "Сбросить фильтры",
  "rep.empty.noCampaigns": "Кампаний нет",
  "rep.empty.noCampaigns.body": "Отчёт считает кампании списка — создайте первую.",
  "rep.foot.rows": "в отчёте {groups} групп на всех уровнях · {top}",
  "rep.foot.truncated": "на экране первые {shown} — сузьте фильтром или уберите уровень",
  "rep.foot.loading": "Строим отчёт… обычно до 2 с; при смене группировки старые строки остаются под затемнением, а не исчезают",
  "rep.foot.empty": "Пусто ≠ сломано: строка здоровья внизу показывает, что клики и постбеки приходят",
  "rep.foot.legend": "клики = люди, боты отсеяны · деньги в USD по курсу дня конверсии",
  "rep.lander.type": "Тип",
  "rep.lander.all": "Все",
  "rep.lander.landings": "Ленды",
  "rep.lander.prelandings": "Преленды",
  "rep.lander.typeNote": "Белые страницы и «Спасибо» не показываются: на них нет LP-клика",
  "rep.lander.crNote": "CR после ленда = лиды / LP-клики",
  "rep.lander.landing": "Ленд",
  "rep.lander.prelanding": "Преленд",
  "rep.lander.vsl": "VSL",
  "rep.lander.danger": "Опасно",
  "rep.offer.paused": "Пауза",
  "rep.offer.capped": "Кап на сегодня",
  "rep.time.title.profit": "Профит по дням недели и часам",
  "rep.time.title.cr": "CR по дням недели и часам",
  "rep.time.title.leads": "Лиды по дням недели и часам",
  "rep.time.title.clicks": "Клики по дням недели и часам",
  "rep.time.measure": "Что в ячейке",
  "rep.time.country": "Страна",
  "rep.time.allCountries": "Все страны",
  "rep.time.noData": "нет данных",
  "rep.time.loss": "убыток",
  "rep.time.gain": "прибыль · за час, USD за {days} дн.",
  "rep.time.tip.sub": "за {days} дн., все кампании",
  "rep.time.byDay": "По дням",
  "rep.time.readings": "Что видно",
  "rep.time.readings.none": "Пока не из чего делать выводы: нет расхода или дохода за период.",
  "rep.time.worst": "Худшие часы: {from}–{to}",
  "rep.time.worst.sub": "минус {loss} USD за {days} дн., CR {cr} против {avg} в среднем",
  "rep.time.best": "Лучшие: {from}–{to}",
  "rep.time.best.day": "Лучшие: {from}–{to}, особенно {day}",
  "rep.time.best.sub": "{share} профита периода за {hours} часов",
  "rep.time.weekend.weaker": "Выходные слабее на {pct}",
  "rep.time.weekend.stronger": "Выходные сильнее на {pct}",
  "rep.time.weekend.sub": "CR {cr} против {avg} в будни",
  "rep.time.schedule": "Расписание показа",
  "rep.time.zone": "часовой пояс аккаунта: {tz}",
  "rep.time.allDay": "весь день",
  "rep.time.copy": "Скопировать для Facebook",
  "rep.time.copied": "Расписание скопировано",
  "rep.time.saves": "сэкономит ≈ {usd} USD за неделю",
  "rep.time.nothingToCut": "убыточных часов нет — крутить весь день",
  "rep.time.byCountry": "По странам",
  "rep.time.col.country": "Страна",
  "rep.wd.1": "Понедельник",
  "rep.wd.2": "Вторник",
  "rep.wd.3": "Среда",
  "rep.wd.4": "Четверг",
  "rep.wd.5": "Пятница",
  "rep.wd.6": "Суббота",
  "rep.wd.7": "Воскресенье",
  "dimNone.owner": "Без баера",
  "dimWord.owner": "баер|баера|баеров",
  "origin.native": "Трекер",
  "origin.imported": "Импорт",
  "dimNone.entry_point": "Без входа",
  "dimWord.entry_point": "вход|входа|входов",
  "entryMatch.queryKey": "Ключ в ссылке",
  "entryMatch.queryValue": "Значение параметра",
  "entryMatch.sticky": "Вернулся (cookie)",
  "entryMatch.fallback": "По умолчанию",
  "entryMatch.rule": "Правило {n}",
  "rep.card.openInReports": "Открыть в Отчётах",
  "rep.card.saveAsReport": "Сохранить как отчёт",
  "rep.card.note": "Один движок отчётов: тот же отчёт, что в разделе «Отчёты», с закреплённым фильтром по этой кампании",
  "rep.card.campaign": "эта",
};
